export const typeColors = {
  identifier: '#407ee7',
  keyword: '#7b9726',
  operator: '#df5320',
  constant: '#3d97b8',
  delimiter: '#000000'
  // invalid : '#FF0000'
};
export const subTypeColors = {
  identifier: {
    alias: '#df5320',
    functionName: '#5f40e7'
  }
};
export const typeUnderline = {
  invalid: 'wavy red 1px'
};
export const black = '#000000';